import React from 'react';
import { deckMeta, deckPages } from '../../data/deck';
interface SlideProps {
  id: string;
  children: React.ReactNode;
}

/** One full-height presentation page with a quiet running header. */
export function Slide({
  id,
  children
}: SlideProps) {
  const index = deckPages.findIndex(page => page.id === id);
  const page = deckPages[index];
  return <section id={id} aria-label={page?.label} className="relative flex min-h-screen w-full flex-col border-t border-navy/[0.08] bg-canvas px-8 py-6 font-sans lg:px-14" data-id="element-39" data-mp="1lrkm8gpw9h8t">
      <header className="flex items-center justify-between gap-4" data-id="element-40" data-mp="1bslauqdqv7i4">
        <span className="text-[10px] uppercase tracking-[0.24em] text-navy/40" data-id="element-41" data-mp="y0wxykvo8f03">
          {String(index + 1).padStart(2, '0')} · {page?.label}
        </span>
        <span className="hidden text-[10px] uppercase tracking-[0.24em] text-navy/25 md:inline" data-id="element-42" data-mp="o1pkzysummdi">
          {deckMeta.running}
        </span>
      </header>
      <div className="flex flex-1 items-center py-12 lg:py-10" data-id="element-43" data-mp="t09a282qoea3">
        <div className="mx-auto w-full max-w-[1360px] lg:pr-10" data-id="element-44" data-mp="2kwiejkxhu2cb">{children}</div>
      </div>
    </section>;
}